import { useEffect, useState } from "react";
import { ChromePicker, SketchPicker } from "react-color";
import styled from "@emotion/styled";
import { useDropdown } from "@editor/components";

export type IToolbarColorInputProps = {
  prefix?: string;
  label?: string;
  onChange?: (value: any) => void;
  value?: any;
  placeholder?: string;
};

const ColorPickerDiv = styled.div`
  position: relative;
  display: flex;
  align-items: center;
`;

const Addon = styled.span<any>`
  position: absolute;
  right: 0;
  display: flex;
  justify-content: space-around;
  align-items: center;
  align-self: stretch;
  width: 22px;
  height: 100%;
  border-radius: 0 3px 3px 0;
  box-shadow: -1px 0 0 0 var(--builder-input-addon-divider);

  width: 20px;
  margin-right: 1px;
  background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAMCAIAAADZF8uwAAAAGUlEQVQYV2M4gwH+YwCGIasIUwhT25BVBADtzYNYrHvv4gAAAABJRU5ErkJggg==)
    4px 0px;

  background-size: 8px;

  i {
    border-radius: 0 3px 3px 0;
    position: absolute;
    top: 0;
    right: 0;
    width: 100%;
    height: 100%;
    box-shadow: 1px 0px;
    background-color: ${(props) => props.bgColor};
    color: ${(props) => props.bgColor};
  }
`;

const Popover = styled.div`
  position: absolute;
  z-index: 2;
`;

const Cover = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
`;

export const ToolbarColorInput = ({
  onChange,
  value,
  prefix,
  label,
  placeholder,
  ...rest
}: IToolbarColorInputProps) => {
  const [internalValue, setInternalValue] = useState(value);
  const { toggleDropdown, isOpen, Dropdown } = useDropdown();

  useEffect(() => {
    if (value) {
      let val = value;
      val = `rgba(${Object.values(value)})`;
      setInternalValue(val);
    }else{
      setInternalValue("transparent")
    }

  }, [value]);

  return (
    <>
      <ColorPickerDiv>
        <input
          type="text"
          spellCheck={false}
          placeholder={placeholder ?? "transparent"}
          value={internalValue || ""}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              onChange?.((e.target as any).value);
            }
          }}
          onChange={(e) => {
            setInternalValue(e.target.value);
          }}
          {...rest}
        />
        <Addon onClick={toggleDropdown} bgColor={internalValue}>
          <i />
        </Addon>
      </ColorPickerDiv>
      {isOpen && (
        <Dropdown >
          <ChromePicker
            color={value}
            onChange={(color: any) => {
              onChange?.(color.rgb);
            }}
          />
        </Dropdown>
      )}
    </>
  );
};
